// #region Imports

import chroma from 'chroma-js';

// #endregion

/**
 * Generates tetradic (square) colors based on the given base color.
 * Tetradic uses four colors evenly spaced around the color wheel (90° apart).
 *
 * @param baseHex - The base color in hex format.
 * @returns An array of three tetradic colors (excluding the base).
 * @public
 */
export function generateTetradicColors(baseHex: string): [string, string, string] {
    const [h, s, l] = chroma(baseHex).hsl();

    return [
        chroma.hsl((h + 90) % 360, s, l).hex(),
        chroma.hsl((h + 180) % 360, s, l).hex(),
        chroma.hsl((h + 270) % 360, s, l).hex()
    ];
}

/**
 * Generates the first tetradic color (90° from base).
 *
 * @param baseHex - The base color in hex format.
 * @returns The first tetradic color.
 * @public
 */
export function generateTetradicColor1(baseHex: string): string {
    const [h, s, l] = chroma(baseHex).hsl();

    return chroma.hsl((h + 90) % 360, s, l).hex();
}

/**
 * Generates the second tetradic color (180° from base - same as complementary).
 *
 * @param baseHex - The base color in hex format.
 * @returns The second tetradic color.
 * @public
 */
export function generateTetradicColor2(baseHex: string): string {
    const [h, s, l] = chroma(baseHex).hsl();

    return chroma.hsl((h + 180) % 360, s, l).hex();
}

/**
 * Generates the third tetradic color (270° from base).
 *
 * @param baseHex - The base color in hex format.
 * @returns The third tetradic color.
 * @public
 */
export function generateTetradicColor3(baseHex: string): string {
    const [h, s, l] = chroma(baseHex).hsl();

    return chroma.hsl((h + 270) % 360, s, l).hex();
}
